// @ts-ignore
/* eslint-disable */
import { request } from '../../request'

/** No comments are provided by the backend POST /projects/${param0}/restore/${param1} */
export async function restoreControllerRestore(
  // Param type generated by superposition
  params: API.RestoreControllerRestoreParams,
  options?: { [key: string]: any },
) {
  const { projectId: param0, versionId: param1, ...queryParams } = params
  return request<any>(`/projects/${param0}/restore/${param1}`, {
    method: 'POST',
    params: { ...queryParams },
    ...(options || {}),
  })
}
